export enum ROUTES_QUERY {
  male = "male",
  female = "female",
  anime_male = "anime_male",
  anime_female = "anime_female",
}

export const ROUTES = {
  BASE: "/",
  HOME: "/explore",
  SUBSCRIBE: "/subscribe",
  PLANS: "/plans",
  REGISTER: "/register",
  LOGIN: "/login",
  RESET: "/reset",
  GALLERY: "/gallery",
  GALLERY_ID: "/gallery/:id",
  ADMIN: "/admin",
  CHAT: "/chat",
  CREATE_AI: "/create_ai",
  MY_AI: "/my_ai",
  MY_AIS: "/my_ais",
  MY_AIS_ID: "/my_ais/:id",
  GENERATE_IMAGE: "/generate_image",
  CHAT_ID: "/chat/:id",
  RESTORE_PASSWORD: "/restore",
  RESET_PASSWORD: "/reset",
  SETTINGS: "/settings",
  CHECKOUT: "/checkout",
  PRIVACY_POLICY: "/privacy_policy",
  TERMS: "/terms",
  SUBID: "/:id",
  PAYWALL: "/paywall",
  ONBOARDING: "/onboarding",
  NOT_FOUND: "*",
} as const;
